import { DefaultTheme } from 'styled-components';

import { breakpoints, mq } from './layout';

export const defaultTheme: DefaultTheme = {
  breakpoints,
  mq,
};
